import config from 'config';
import Raven from 'raven-js';

function initRaven() {
  Raven.config(config.SENTRY.DSN).install();
  Raven.setTagsContext({
    environment: config.SENTRY.environment
  });
}

if (!Raven.isSetup()) {
  initRaven();
}

export default Raven;



// WEBPACK FOOTER //
// ./src/libs/Raven.js